import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Fernwell Counseling',
    description: "Anxiety and burnout therapy for women in Olympia, WA and online across Washington. Practical skills, evening telehealth times and a free 15-minute consult.",
    url: 'https://fernwell-counseling.modulify.website',
    ogImage: '/images/home-hero-office.jpg',
    // Placeholder for the practice site. Swap in the real SimplePractice booking link here and every booking button follows.
    bookingUrl: 'https://www.simplepractice.com/',
    contact: {
        email: 'hello@fernwellcounseling.example',
        phone: '(360) 555-0142',
        phoneHref: 'tel:+13605550142',
        location: "Downtown Olympia, Washington, and online anywhere in Washington",
        hours: "Monday to Thursday, 10 AM to 7 PM",
        instagramHandle: '@fernwellcounseling.example',
        instagramUrl: 'https://www.instagram.com/fernwellcounseling.example/'
    }
}
